import { Navigate } from 'react-router-dom';

export const AppNavigation = ({
  token,
}: {
  token: string | undefined;
}) => {
  if (token) {
    return <Navigate to="/" replace />;
  } else {
    return <Navigate to="/sign-in" replace />;
  }
};
